const typeStyles = () => {
    const richtextFields = document.querySelectorAll('[data-lbdo-richtext]');
    richtextFields.forEach((text) => {
        const children = text.querySelectorAll('*');
        children.forEach((child) => {
            let string;
            const innerHTML = child.innerHTML;
            string = innerHTML;
            const hasHeadingFont = innerHTML.match(/\*(.*?)\*/);
            if (hasHeadingFont) {
                const headingWrapper = '<span class="ff-heading">' + hasHeadingFont[1] + '</span>';
                string = innerHTML.replace(/\*(.*?)\*/, headingWrapper);
            }
            const hasHightlight = string.match(/\^(.*?)\^/);
            if (hasHightlight) {
                const highlightWrapper = '<span class="text-highlight">' + hasHightlight[1] + '</span>';
                string = string.replace(/\^(.*?)\^/, highlightWrapper);
            }
            child.innerHTML = string;
        });
    });
};
export { typeStyles };
